var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "senior_wrap" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.productFlag == 3
        ? _c("ul", { staticClass: "taxation_item" }, [
            _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappcsT:dsj")
              ? _c(
                  "li",
                  [
                    _c("img", {
                      staticClass: "app_logo",
                      staticStyle: { height: "30px" },
                      attrs: { src: require("../img/dsj-logo.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "app_bg",
                      attrs: { src: require("../img/ctx-bg.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.entrySys("dsj")
                          }
                        }
                      },
                      [_vm._v("进入系统")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappcsT:jxgl")
              ? _c(
                  "li",
                  [
                    _c("img", {
                      staticClass: "app_logo",
                      staticStyle: { height: "24px" },
                      attrs: { src: require("../img/jxgl-logo.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "app_bg",
                      attrs: { src: require("../img/ptx-bg.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.entrySys("jxgl")
                          }
                        }
                      },
                      [_vm._v("进入系统")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappcsT:ysgl")
              ? _c(
                  "li",
                  [
                    _c("img", {
                      staticClass: "app_logo",
                      staticStyle: { height: "24px" },
                      attrs: { src: require("../img/ysgl-logo.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "app_bg",
                      attrs: { src: require("../img/jss-bg.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [_vm._v("（2.0）")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.entrySys("ysgl")
                          }
                        }
                      },
                      [_vm._v("进入系统")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappcsT:cbgl")
              ? _c(
                  "li",
                  [
                    _c("img", {
                      staticClass: "app_logo",
                      staticStyle: { height: "24px" },
                      attrs: { src: require("../img/cbgl-logo.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "app_bg",
                      attrs: { src: require("../img/zwfz-bg.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [_vm._v("（1.0）")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.entrySys("glkj")
                          }
                        }
                      },
                      [_vm._v("进入系统")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappcsT:znfp")
              ? _c(
                  "li",
                  [
                    _c("img", {
                      staticClass: "app_logo",
                      attrs: { src: require("../img/znfp-logo.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "app_bg",
                      attrs: { src: require("../img/znfp-bg.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.entrySysDefault("ptx")
                          }
                        }
                      },
                      [_vm._v("进入系统")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappcsT:znnssb")
              ? _c(
                  "li",
                  [
                    _c("img", {
                      staticClass: "app_logo",
                      attrs: { src: require("../img/znnssb-logo.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "app_bg",
                      attrs: { src: require("../img/zncssb-bg.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.entrySysDefault("jss")
                          }
                        }
                      },
                      [_vm._v("进入系统")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappcsT:swfzpt")
              ? _c(
                  "li",
                  [
                    _c("img", {
                      staticClass: "app_logo",
                      attrs: { src: require("../img/swfzpt-logo.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "app_bg",
                      attrs: { src: require("../img/swfzpt-bg.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.showDialog("swfzpt")
                          }
                        }
                      },
                      [_vm._v("进入系统")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappcsT:swfxgl")
              ? _c(
                  "li",
                  [
                    _c("img", {
                      staticClass: "app_logo",
                      attrs: { src: require("../img/swfxgl-logo.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "app_bg",
                      attrs: { src: require("../img/swfxgl-bg.png"), alt: "" }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.showDialog("swfxgl")
                          }
                        }
                      },
                      [_vm._v("进入系统")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.centerDialogVisible,
            width: "400px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.centerDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "cont" }, [
            _c("p", [_vm._v("请选择您要进入的案例公司：")]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.companyList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: { active: index === _vm.curId },
                    on: {
                      click: function($event) {
                        return _vm.tabClick(item, index)
                      }
                    }
                  },
                  [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]
                )
              }),
              0
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.linkDialogVisible, width: "420px", center: "" },
          on: {
            "update:visible": function($event) {
              _vm.linkDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "cont" }, [
            _c(
              "ul",
              { staticStyle: { width: "185px" } },
              _vm._l(_vm.linkList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: { active: index === _vm.curIndex },
                    on: {
                      click: function($event) {
                        return _vm.linkTabClick(item, index)
                      }
                    }
                  },
                  [_vm._v("\n          " + _vm._s(item) + "\n        ")]
                )
              }),
              0
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "taxation_title" }, [
      _c("h2", [_vm._v("智能财税高级")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63e77bcf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e77bcf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/appCenter/components/senior.vue
// module id = null
// module chunks = 